import React from 'react';
import { useIstClock } from './ist-datetime';
import './IstClock.css';

/** Live IST date + time — shown on every screen via GlobalTradingNav */
export default function IstClock({ className = '' }) {
  const label = useIstClock(1000);
  return (
    <time className={`ist-clock ${className}`.trim()} dateTime={new Date().toISOString()} title="India Standard Time">
      {label || '—'}
    </time>
  );
}
